import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import gsap from "gsap";

const PageTransition = ({ children }) => {
  const location = useLocation();
  const pageRef = useRef(null);
  const timeline = useRef(null);

  useEffect(() => {
    // Create a new timeline for each transition
    timeline.current = gsap.timeline({
      defaults: {
        ease: "power2.inOut",
      },
    });

    // Reset scroll position
    window.scrollTo(0, 0);

    // Exit animation for old content
    timeline.current
      .to(pageRef.current, {
        opacity: 0,
        y: -20,
        duration: 0.3,
      })
      // Enter animation for new content
      .fromTo(
        pageRef.current,
        {
          opacity: 0,
          y: 20,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
        }
      );

    return () => {
      if (timeline.current) {
        timeline.current.kill();
      }
    };
  }, [location.pathname]);

  return (
    <div ref={pageRef} className="w-full">
      {children}
    </div>
  );
};

export default PageTransition;
